import { Button, Center } from "@chakra-ui/react";
import { GaugePieChart } from "../../../../../landing/tabs/collections/chartComponents/GaugeChart/GaugePieChart";
import { BiDollarCircle, BiInfoCircle } from "react-icons/bi";
import { SectionWrapper } from "../SectionWrapper";
import React from "react";
import { useButtonProps } from "../../../../../../hooks";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  score: number | null | undefined;
  showMoreAbout?: boolean;
  showRaiseCapitalRound?: boolean;
  showPerformValuation?: boolean;
}
function SectionInvestorReadiness({ score, showMoreAbout, showRaiseCapitalRound, showPerformValuation, ...props }: Props) {
  const buttonPropsMoreAbout = useButtonProps("sm", "primary");
  const buttonPropsRaise = useButtonProps("sm", "subscribe");
  const buttonPropsValuation = useButtonProps("sm", "primary");

  return (
    <SectionWrapper title="Investor Readiness" {...props}>
      <Center>
        <GaugePieChart value={score ?? 0} size="300px" />
      </Center>
      <Center gap={2}>
        {showMoreAbout && (
          <Button {...buttonPropsMoreAbout} leftIcon={<BiInfoCircle />}>
            More about Investor Relations
          </Button>
        )}
        {showRaiseCapitalRound && (
          <Button {...buttonPropsRaise} leftIcon={<BiDollarCircle />}>
            Raise Capital Round
          </Button>
        )}
        {showPerformValuation && (
          <Button {...buttonPropsValuation} leftIcon={<BiDollarCircle />}>
            Perform AI Valuation
          </Button>
        )}
      </Center>
    </SectionWrapper>
  );
}

export default React.memo(SectionInvestorReadiness);
